export default "__VITE_ASSET__dcbaacd8__"